<template>
  <div >

      <Tabs  @on-click="handleTabClick" v-model="tabsVal">
        <TabPane label="关注回复" name="name1">
          <weixin-follow ref="follow"></weixin-follow>
        </TabPane>
        <TabPane label="关键词回复" name="name2">
          <check-c-n ref="checkCN"></check-c-n>
        </TabPane>
        <TabPane label="收到消息回复" name="name3">
          <check-c-i ref="checkCI"></check-c-i>
        </TabPane>
        <TabPane label="微信菜单回复" name="name4">
          <check-y-s ref="checkYS"></check-y-s>
        </TabPane>

      </Tabs>
    </div>
</template>
<script>
import weixinFollow from "./weixinFollow";
import checkCN from "./weixinKeyWord";
import checkCI from "./weixinMessage";
import checkYS from "./weixinMenuDict";
import getAuthOrization from "@/mixin/getAuthOrization";

export default {
  name: 'findCarInfo',
  mixins: [getAuthOrization],
  components: {weixinFollow,checkCN, checkCI, checkYS},
  data() {
    return {
      tabsVal: "name1",
    }
  },
  methods: {
    handleTabClick(name) {
    if (name == "name1"){
      this.$refs.follow.init();
    }
    else if (name == "name2"){
        this.$refs.checkCN.init();
      }
    else if (name == "name3"){
        this.$refs.checkCI.init();
      }
    else if (name == "name4"){
        this.$refs.checkYS.init();
      }
    }
  }
}
</script>
<style>

</style>